<template>
<div>
  <div class="mb-2 font-medium">
    1. Place the code below within the <code class="px-2 bg-gray-300 rounded">&lt;head&gt;&lt;/head&gt;</code> of your HTML markup.
  </div>
  <pre class="mb-4 select-all"><code class="rounded-md xml">&lt;script src=&quot;//vxml4.plavxml.com/sited/ref/ctrk/598-{{ $route.params.cid }}&quot; async&gt;&lt;/script&gt;</code></pre>
  <div>
    Example
  </div>
  <pre class="mb-5"><code class="rounded-md xml">&lt;!DOCTYPE html&gt;
&lt;html lang=&quot;en&quot;&gt;
&lt;head&gt;
  &lt;meta charset=&quot;UTF-8&quot;&gt;
  &lt;meta name=&quot;viewport&quot; content=&quot;width=device-width, initial-scale=1.0&quot;&gt;
  &lt;title&gt;Title&lt;/title&gt;
  &lt;script src=&quot;//vxml4.plavxml.com/sited/ref/ctrk/598-{{ $route.params.cid }}&quot; async&gt;&lt;/script&gt;
&lt;/head&gt;
&lt;body&gt;
  
&lt;/body&gt;
&lt;/html&gt;</code></pre>
  <div class="mb-2 font-medium">
    2. Wrap your hyperlink telephone number to be tracked with <code class="px-2 bg-gray-300 rounded">&lt;span&gt;&lt;/span&gt;</code> tag.
  </div>
  <div>
    Example
  </div>
  <pre class="select-all"><code class="rounded-md xml">&lt;a href=&quot;tel:+65{{ $route.params.telephone }}&quot;&gt;&lt;span&gt;+65 {{ $route.params.telephone }}&lt;/span&gt;&lt;/a&gt;</code></pre>
</div>

</template>

<script>
  export default {
    
  }
</script>

<style>
.hljs-params {
  @apply text-red-500;
}
</style>